var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _GlobError_hasClickErrors;
import { PIC } from '../templates/Internals';
export class GlobError {
    constructor() {
        _GlobError_hasClickErrors.set(this, false);
        this.errorHolder = [];
    }
    sendTimer() {
        this.sendTimeoutId ? clearTimeout(this.sendTimeoutId) : '';
        this.sendTimeoutId = setTimeout(() => {
            this.sendError();
            this.sendTimeoutId = undefined;
        }, 1000);
    }
    getStringError() {
        let returnStr = '';
        this.errorHolder.forEach((iErr) => {
            returnStr +=
                `
                <-------------------------------------------------------------------------->
                    Uncaught JS Error
                    Timestamp: [${iErr.Timestamp ? iErr.Timestamp.toISOString() : ''}]
                    System: [${iErr.System}]
                    Session: [${iErr.Session}]
                    Subwin: [${iErr.Subwin}]
                    ActiveModal: [${iErr.ActiveModal}]
                    -------
                    Message: [${iErr.Message}]
                    Stack: [${iErr.Stack}]
                    File: [${iErr.File}]
                    Line: [${iErr.Line}]
                    Column: [${iErr.Column}]
                    Error: [${JSON.stringify(iErr.Error)}]
                <-------------------------------------------------------------------------->
                `;
        });
        return returnStr;
    }
    getHtmlError() {
        let tds = 'style="padding: 10px"';
        let top = `
        <html>
        <head>
            <title>PIC Error mail</title>
        </head>
        <body>
            <p>UserAgent: ${navigator.userAgent}</p>
            <p>Script Version: ${PIC.getInstance.appVersion}</p>
            <table width="fit-content" border="1" cellpadding="0" cellspacing="0" width="600"
                style="border-collapse: collapse; border: 1px solid #ddd;">
                <thead align="left">
                    <tr align="center" style="border: 1px solid #ddd;">
                        <th height="35" colspan="12" bgcolor="#003767"
                            style="color: #ffffff; font-family: Arial, sans-serif; font-size: 16px; line-height: 20px; ">
                            Uncaught JS Error
                        </th>
                    </tr>
                    <tr style="color: #626364;">
                        <th>Timestamp</th>
                        <th>System</th>
                        <th>Session</th>
                        <th>Subwin</th>
                        <th>Target</th>
                        <th>ActiveModal</th>
                        <th>Message</th>
                        <th>Stack</th>
                        <th>File</th>
                        <th>Line</th>
                        <th>Column</th>
                        <th>Error</th>
                    </tr>
                </thead>
                <tbody>`;
        let mid = '';
        this.errorHolder.forEach((pe) => {
            mid += `<tr>`;
            mid += `<td ${tds}>${pe.Timestamp ? pe.Timestamp.toISOString() : ''}</td>`;
            mid += `<td ${tds}>${pe.System}</td>`;
            mid += `<td ${tds}>${pe.Session}</td>`;
            mid += `<td ${tds}>${pe.Subwin}</td>`;
            mid += `<td ${tds}>${pe.Target}</td>`;
            mid += `<td ${tds}>${pe.ActiveModal}</td>`;
            mid += `<td ${tds}>${pe.Message}</td>`;
            mid += `<td ${tds}>${pe.Stack}</td>`;
            mid += `<td ${tds}>${pe.File}</td>`;
            mid += `<td ${tds}>${pe.Line}</td>`;
            mid += `<td ${tds}>${pe.Column}</td>`;
            mid += `<td ${tds}>${(pe.Error)}</td>`;
            mid += `</tr>`;
        });
        let bottom = `
                </tbody>
            </table>
            <br/><br/>
            ${this.getHtmlConsoleLog()}
        </body>
        </html>
      `;
        return top + mid + bottom;
    }
    getHtmlConsoleLog() {
        let tds = 'style="padding: 10px; white-space: nowrap;"';
        let tds2 = 'style="padding: 10px"';
        let top = `
        <body>
            <table width="fit-content" border="1" cellpadding="0" cellspacing="0" width="600"
                style="border-collapse: collapse; border: 1px solid #ddd;">
                <thead align="left">
                    <tr align="center" style="border: 1px solid #ddd;">
                        <th height="35" colspan="4" bgcolor="#003767"
                            style="color: #ffffff; font-family: Arial, sans-serif; font-size: 16px; line-height: 20px; ">
                            Console Log
                        </th>
                    </tr>
                    <tr style="color: #626364;">
                        <th>Timestamp</th>
                        <th>Type</th>
                        <th>Log</th>
                        <th>Trace</th>
                    </tr>
                </thead>
                <tbody>`;
        let mid = '';
        PIC.consoleLog.forEach(x => {
            mid += `<tr>`;
            mid += `<td ${tds}>${x.timeStamp.toISOString()}</td>`;
            mid += `<td ${tds}>${x.type}</td>`;
            mid += `<td ${tds}>${x.message}</td>`;
            mid += `<td ${tds}>${x.trace ? x.trace : ''}</td>`;
            mid += `</tr>`;
        });
        let bottom = `
                </tbody>
            </table>
      `;
        //Clear consoleLog after error
        PIC.consoleLog = [];
        //Dont send consoleLog if its turened off
        if (sessionStorage.getItem("overrideConsoleLog") && sessionStorage.getItem("overrideConsoleLog") === 'true')
            return top + mid + bottom;
        else
            return '';
    }
    getHtmlAppStack(iObj) {
        return `
        <html>
            <head>
                <title>PIC Error mail</title>
            </head>
            <body>
                <p>User <b>${PIC.user}</B>, May have experienced tab session logout </p>
                <p>AppStack:</p>
                ${JSON.stringify(iObj, null, 2).replace(/^ +/mg, (match) => match.replace(/ /g, "&nbsp;")).replace(/(?:\r\n|\r|\n)/g, '<br>')}    
            </body>
        </html>`;
    }
    getErrorsAsObject() {
        let browser = null;
        let platform = null;
        if ('userAgentData' in window.navigator) { //only in Chromium
            //@ts-ignore until navigator type file gets updated
            platform = navigator.userAgentData.platform;
            //@ts-ignore
            browser = navigator.userAgentData.brands[0].brand;
        }
        if (window.navigator.userAgent.includes('Mac')) {
            platform = 'Mac';
        }
        else if (window.navigator.userAgent.includes('Linux')) {
            platform = 'Linux';
        }
        const ErrorObject = this.errorHolder.map((err) => {
            var _a, _b;
            return {
                created_at: err.Timestamp.getTime(),
                error_type: 'web',
                error_level: 0,
                error_source: location.hostname + location.pathname,
                system: err.System,
                user: (_b = (_a = err.Session.split('.')) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'unknown',
                session: err.Session,
                program: err.Subwin,
                stacktrace: err.Stack,
                message: err.Message,
                occurences: 1,
                client_version: PIC.getInstance.appVersion,
                client_type: browser || null,
                client_os: platform || null,
                client_os_version: null,
                client_java_version: null,
                client_info: `WebVersion=${PIC.getInstance.webVersion}&userAgent=` + navigator.userAgent
            };
        });
        return JSON.stringify(ErrorObject);
    }
    triggerErrorOnClick() {
        const removeEventListener = __classPrivateFieldGet(this, _GlobError_hasClickErrors, "f");
        if (removeEventListener)
            window.removeEventListener('click', this.testError);
        else
            window.addEventListener('click', this.testError);
        __classPrivateFieldSet(this, _GlobError_hasClickErrors, !__classPrivateFieldGet(this, _GlobError_hasClickErrors, "f"), "f");
    }
    testError(iEvent) {
        throw new Error('test error');
    }
    addError(iEvent) {
        var _a, _b, _c, _d, _e;
        if (iEvent.message && ((_a = iEvent.message.toString()) === null || _a === void 0 ? void 0 : _a.startsWith('ResizeObserver loop limit exceeded')))
            return;
        if (iEvent.message && ((_b = iEvent.message.toString()) === null || _b === void 0 ? void 0 : _b.startsWith('ResizeObserver loop completed with undelivered notifications')))
            return;
        console.log(iEvent);
        if (iEvent.error && ((_c = iEvent.error.toString()) === null || _c === void 0 ? void 0 : _c.startsWith('EvalError:')))
            return;
        let errMsg;
        /* regular error */
        if (iEvent.message) {
            errMsg = {
                Timestamp: new Date(),
                System: PIC.systemId,
                Session: PIC.sessionCode,
                Subwin: (_d = PIC.subwin) !== null && _d !== void 0 ? _d : PIC.moduleId,
                ActiveModal: [],
                Message: iEvent.message,
                Target: iEvent.target ? iEvent.target.constructor.name : '',
                Stack: iEvent.error ? iEvent.error.stack ? iEvent.error.stack : '' : '',
                File: iEvent.filename,
                Line: iEvent.lineno,
                Column: iEvent.colno,
                Error: iEvent.error,
            };
            /* captured error, stringify it and pray you get something usefull*/
        }
        else {
            let msgStr = '';
            try {
                if (iEvent.target.id == 'logo2')
                    return;
                msgStr = iEvent.target.outerHTML;
            }
            catch (_f) {
                msgStr = JSON.stringify(iEvent);
            }
            errMsg = {
                Timestamp: new Date(),
                System: PIC.systemId,
                Session: PIC.sessionCode,
                Subwin: (_e = PIC.subwin) !== null && _e !== void 0 ? _e : PIC.moduleId,
                ActiveModal: [],
                Message: msgStr,
                Stack: '',
                File: '',
                Line: 0,
                Column: 0,
                Error: ''
            };
        }
        this.errorHolder.push(errMsg);
        if (this.errorHolder.length > 50) {
            this.sendError();
        }
        else {
            this.sendTimer();
        }
    }
    sendError() {
        PIC.getInstance.msg('Sending', this.errorHolder.length, 'error(s)');
        if (this.errorHolder.length > 0) {
            const eUrl = `/events/errorSrv?sysid=${PIC.systemId}&errType=js`;
            const body = {
                html: this.getHtmlError(),
                obj: this.getErrorsAsObject()
            };
            //console.log('what is sent', JSON.stringify(body))
            fetch(eUrl, {
                method: 'POST',
                headers: [['Content-Type', 'text/plain; charset=UTF-8']],
                body: JSON.stringify(body)
                //body: this.getHtmlError()
                // body: this.getStringError()
            }).then(() => {
                this.errorHolder = [];
            }).catch(() => PIC.getInstance.msg('send error has failed'));
        }
    }
    sendAppStack(iObj) {
        const eUrl = `/html/errorsrv?sysid=${PIC.systemId}`;
        fetch(eUrl, {
            method: 'POST',
            headers: [['Content-Type', 'text/plain; charset=UTF-8']],
            body: this.getHtmlAppStack(iObj)
        }).then(() => {
            this.errorHolder = [];
        }).catch(() => PIC.getInstance.msg('send error has failed'));
    }
}
_GlobError_hasClickErrors = new WeakMap();
//# sourceMappingURL=GlobError.js.map